import { Typography, Box, styled } from '@mui/material';

export const StyledSubscriptionGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(3),
  gridTemplateColumns: 'repeat(12, 1fr)',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(2, 0),
  },
}));

export const StyledSubscriptionBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gridColumn: 'span 4',
  padding: theme.spacing(2),
  gap: theme.spacing(1.5),
  background: theme.palette.grey[800],
  borderRadius: theme.spacing(1),
  [theme.breakpoints.down('xl')]: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
}));

export const StyledAccountTypeAndLabelContainer = styled(Typography)(
  ({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    [theme.breakpoints.down('xl')]: {
      gap: theme.spacing(1),
    },
  })
);

export const StyledProductDescription = styled(Typography)(() => ({
  fontSize: 12,
}));

export const StyledProductInfo = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
  lineHeight: theme.spacing(4),
}));

StyledProductDescription.defaultProps = {
  variant: 'body1',
};
